export const resolveAssetUrl = (baseUrl, assetPath) => {
  const normalizedPath = String(assetPath || "").trim();

  if (!normalizedPath) {
    return "";
  }

  if (/^https?:\/\//i.test(normalizedPath)) {
    return normalizedPath;
  }

  const normalizedBase = String(baseUrl || "").trim().replace(/\/+$/, "");
  const cleanedPath = normalizedPath.replace(/^\/+/, "");

  if (!normalizedBase) {
    return cleanedPath;
  }

  return `${normalizedBase}/${cleanedPath}`;
};
